export const storage = `${process.env.REACT_APP_API_HOST}/storage`
export const host = process.env.REACT_APP_API_HOST
